export default "__VITE_ASSET__3bzY41Oi__";